'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.DualListbox', ['jqwidgets']).directive('rmDualListbox', require('./directives/DualListboxDirective'));